module.exports = __webpack_public_path__ + "static/media/coinsilium.d8c021a5.png";